import axios from "axios";
import { registerAuthInterceptor } from "./interceptors/requestAuthInterceptor";
import { registerParamsInterceptor } from "./interceptors/parseParamsInterceptor";

const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL ?? "",
});

setTimeout(() => {
  registerAuthInterceptor(axiosClient);
  registerParamsInterceptor(axiosClient);
}, 0);

export default axiosClient;
